/* AlarmVideo — mobile header + filter dropdown. Loaded (deferred) after av.js,
   so its DOMContentLoaded handler and ResizeObserver run after av.js's and win
   the --av-header-h variable. */
(function () {
  'use strict';

  var PHONE = '(max-width: 760px)';   /* same breakpoint as av.css .av-header__bar wrap */
  var TABLET = '(max-width: 900px)';  /* same breakpoint as the filter sidebar going static */

  /* 4. Sticky header on phones: only the search field + category nav stay
        pinned. #header-group keeps position:sticky (av.css), but gets a
        negative top equal to the height of the rows above the search field
        (top bar, logo, buttons), so those scroll away and the rest sticks.
        --av-header-h (used by scroll-margin and the desktop filter sidebar)
        is set to the part that actually stays visible. */
  function initMobileSticky() {
    var header = document.getElementById('header-group');
    var search = header && header.querySelector('.av-search');
    if (!header || !search) return;
    var mq = window.matchMedia(PHONE);

    function apply() {
      var box = header.getBoundingClientRect();
      var full = box.height;
      if (mq.matches) {
        var offset = Math.max(0, Math.round(search.getBoundingClientRect().top - box.top));
        header.style.top = (-offset) + 'px';
        document.documentElement.style.setProperty('--av-header-h', (full - offset) + 'px');
      } else {
        header.style.top = '';
        document.documentElement.style.setProperty('--av-header-h', full + 'px');
      }
    }

    apply();
    if (window.ResizeObserver) new ResizeObserver(apply).observe(header);
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  /* 3. Filters dropdown on phones/tablets: tap the "Filters" head to open or
        close the list. av.js replaces the whole collection root after every
        filter change, so the open state is kept here and re-applied. */
  function initFilterToggle() {
    var open = false;

    function apply() {
      var sb = document.querySelector('.av-filters-sidebar');
      if (sb) sb.classList.toggle('is-open', open);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var head = t.closest('.av-filters-sidebar__head');
      if (!head || t.closest('a')) return;             /* "Wissen" link keeps working */
      if (!window.matchMedia(TABLET).matches) return;  /* desktop sidebar is always open */
      open = !open;
      apply();
    });

    if (window.MutationObserver) {
      new MutationObserver(function () { if (open) apply(); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  /* 5. "Menu" dropdown on phones: the toggle opens/closes the category list.
        Closing also folds any open category panel (av.js keeps those open). */
  function initMenuToggle() {
    var wrap = document.querySelector('[data-av-nav]');
    var btn = wrap && wrap.querySelector('[data-av-nav-toggle]');
    if (!wrap || !btn) return;

    function set(open) {
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) {
        wrap.querySelectorAll('[data-av-nav-item].is-open').forEach(function (b) {
          b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false');
        });
        wrap.querySelectorAll('[data-av-nav-panel]').forEach(function (p) { p.hidden = true; });
        var scrim = wrap.querySelector('[data-av-nav-scrim]');
        if (scrim) scrim.hidden = true;
      }
    }

    btn.addEventListener('click', function () { set(!wrap.classList.contains('is-open')); });
    wrap.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a');
      if (a && window.matchMedia(PHONE).matches) set(false);
    });
    var mq = window.matchMedia(PHONE);
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) set(false); });
  }

  function boot() { initMobileSticky(); initFilterToggle(); initMenuToggle(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
